import { styled } from '@creditas/stylitas'
import { TableRow } from '@creditas/table'

const CustomRow = styled(TableRow)<{
  warning?: boolean
  clickable?: boolean
  onClick?: () => void
  onMouseEnter?: () => void
  onMouseLeave?: () => void
  style?: object
}>`
  background-color: ${({ warning }): string =>
    warning ? '#FFFFCC !important' : 'inherit'};
  ${({ clickable }) => (clickable ? 'cursor: pointer;' : '')}
`

export { CustomRow as TableRow }
